import {currencyToString} from './util';
import get from 'lodash/get';

export function formatAppleData(productArray = [], options = {}) {
  const uidProperty = options.uidProperty || 'sku';

  return productArray
    .filter((product) => product?.appleLabels)
    .map((entry) => {
      return {
        // Consumer price object already formatted as entry.consumerPrice in BulkProductGridTabs
        advertisedPrice: entry.consumerPrice ?? getConsumerPrice(entry.price || {}),
        id: entry[uidProperty],
        msrp: entry.consumerPrice ? get(entry, 'consumerPrice.advertised.low.formatted') : entry.price?.msrp,
        retailLabelDescription: entry.appleLabels.retailLabelDescription || '',
        retailLabelPrice: currencyToString(entry.appleLabels.retailLabelPrice || ''),
        retailLabelProductId: entry.appleLabels.retailLabelProductId || '',
        retailLabelStatus: entry.appleLabels.retailLabelStatus || false,
        sku: entry[uidProperty],
      };
    });
}

function getConsumerPrice(price) {
  return {
    advertised: {
      low: {
        formatted: price.msrp,
      },
    },
    saleAdvertised: {
      low: {
        formatted: price.saleAdvertised,
      },
    },
  };
}
